const CommonClientVariables = [
  "$FirstName$",
  "$LastName$",
  "$Email$",
  "$Phone$",
];

export default { CommonClientVariables };
